'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Component = require('../../Component');

var _Component2 = _interopRequireDefault(_Component);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _main = require('../templates/main');

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Main = function (_View) {
    _inherits(Main, _View);

    function Main(props) {
        var _ret;

        _classCallCheck(this, Main);

        var _this = _possibleConstructorReturn(this, (Main.__proto__ || Object.getPrototypeOf(Main)).call(this, props));

        _initialiseProps.call(_this);

        var active = props.children[props.active] ? props.active : 0;

        _this.state = {
            // active slide
            active: active,
            prevActive: active,
            animating: false,
            // признак откуда выедет новость из слайдера (1|-1)
            appearDirection: 1
        };

        return _ret = _this, _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Main, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.autoPlay();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (prevProps.autoPlay !== this.props.autoPlay) {
                this.autoPlay(this.props.autoPlay);
            }
        }
    }]);

    return Main;
}(_Component2.default);

Main.defaultProps = {
    active: 0,
    // show bullets bar
    showBullets: true,
    // change slide by interval
    autoPlay: false,
    // autoPlay interval
    autoPlayInterval: 5000,
    // switch between slides time
    timeout: 500,
    // showing navigation arrows
    showNavigation: false,
    // shows counter like: 1 of 5, 1 из 5, 1 з 5
    showCounter: false,
    children: []
};
Main.propTypes = {
    active: _propTypes2.default.number,
    showBullets: _propTypes2.default.bool,
    autoPlay: _propTypes2.default.bool,
    autoPlayInterval: _propTypes2.default.number,
    timeout: _propTypes2.default.number,
    showNavigation: _propTypes2.default.bool,
    showCounter: _propTypes2.default.bool
};
Main.displayName = 'Slider';

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.template = _main2.default;

    this.toSlide = function (to) {
        var active = _this2.state.active,
            dir = 0;


        if (active === to) {
            return;
        }

        if (active > to) {
            dir = -1;
        } else if (active < to) {
            dir = 1;
        }

        _this2._moveSlide(active, to, dir);
    };

    this.navigate = function () {
        var dir = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        var active = _this2.state.active,
            children = _this2.props.children,
            to = active + dir;


        if (!children[to]) {
            if (dir > 0) {
                to = 0;
            } else if (dir < 0) {
                to = _react2.default.Children.count(children) - 1;
            }
        }

        return _this2._moveSlide(active, to, dir);
    };

    this.autoPlay = function () {
        var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this2.props.autoPlay;

        if (flag) {
            _this2._autoPlayInterval = setInterval(_this2.navigate, _this2.props.autoPlayInterval);
        } else if (!flag) {
            _this2._autoPlayInterval && clearInterval(_this2._autoPlayInterval);
        }
    };

    this._moveSlide = function (active, to, dir) {
        if (_this2.state.animating) {
            return new Promise(function (resolve) {
                return resolve();
            });
        }
        var nextState = {
            active: to,
            prevActive: active,
            appearDirection: dir
        };

        if (_this2.props.slideHeight !== null) {
            nextState.slideHeight = 'auto';
        }

        return _this2.setState(nextState).then(function () {
            return _this2.setState({ animating: true });
        });
    };

    this.handleAnimationEnd = function (e) {
        if (e && e.currentTarget === e.target) {
            _this2.setState({ animating: false, prevActive: _this2.state.active });
        }
    };
};

exports.default = Main;